<template>
  <div>
    <FormSectionContainer index="1" title="Tőketermék adatai">
      <label for="capitalProductData.finance">Finanszírozás formája<span class="required-star"></span></label>
      <b-form-textarea
        id="capitalProductData.finance"
        v-model="capitalProductData.finance"
        placeholder="Adja meg a finanszírozás formáját"
        trim
        rows="6"
        style="min-height: 150px;"
        class="mb-3"
        :state="finance"
        :class="`${finance !== null && !finance ? 'create-fund-error-border' : ''}`"
      ></b-form-textarea>

      <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
        Adja meg a finanszírozás formáját
      </b-form-invalid-feedback>

      <b-row>
        <b-col cols="12" md="6" lg="6" xl="6">
          <label for="capitalProductData.financeMin">Finanszírozás minimuma</label>
          <div class="input-symbol-forint">
            <b-form-input
              id="capitalProductData.financeMin"
              v-model="capitalProductData.financeMin"
              @keypress="isNumber($event, true)"
              placeholder="Adja meg a hitelösszeg minimumát"
              trim
              class="mb-3"
            ></b-form-input>
          </div>
        </b-col>
        <b-col cols="12" md="6" lg="6" xl="6"
          ><label for="capitalProductData.financeMax">Finanszírozás maximuma</label>
          <div class="input-symbol-forint">
            <b-form-input
              id="capitalProductData.financeMax"
              v-model="capitalProductData.financeMax"
              @keypress="isNumber($event, true)"
              placeholder="Adja meg a hitelösszeg maximumát"
              trim
              class="mb-3"
            ></b-form-input>
          </div>
        </b-col>
      </b-row>

      <label for="capitalProductData.ownershipShare">Megszerzett tulajdonrész<span class="required-star"></span></label>
      <b-form-textarea
        id="capitalProductData.ownershipShare"
        v-model="capitalProductData.ownershipShare"
        placeholder="Adja meg a megszerzett tulajdonrész mértékére vonatkozó korlátokat"
        trim
        rows="6"
        style="min-height: 150px;"
        class="mb-4"
        :state="ownershipShare"
        :class="`${ownershipShare !== null && !ownershipShare ? 'create-fund-error-border' : ''}`"
      ></b-form-textarea>

      <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
        Adja meg a megszerzett tulajdonrész mértékét
      </b-form-invalid-feedback>

      <b-row class="mb-3">
        <label class="col-12" for="investmentTermMin">Befektetés időtartama<span class="required-star"></span></label>
        <b-col cols="6" sm="4" md="4" lg="5" xl="5">
          <b-form-input
            id="capitalProductData.investmentTermMin"
            v-model="capitalProductData.investmentTermMin"
            @keypress="isNumber($event, true)"
            placeholder="Minimum"
            trim
            :state="investmentTermMin"
            :class="`${investmentTermMin !== null && !investmentTermMin ? 'create-fund-error-border' : ''}`"
          ></b-form-input>
          <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
            Adja meg a befektetés időtartamának minimumát
          </b-form-invalid-feedback>
        </b-col>

        <b-col cols="6" sm="4" md="4" lg="5" xl="5">
          <b-form-input
            id="capitalProductData.investmentTermMax"
            v-model="capitalProductData.investmentTermMax"
            @keypress="isNumber($event, true)"
            placeholder="Maximum"
            trim
            :state="investmentTermMax"
            :class="`${investmentTermMax !== null && !investmentTermMax ? 'create-fund-error-border' : ''}`"
          ></b-form-input>
          <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
            Adja meg a befektetés időtartamának maximumát
          </b-form-invalid-feedback>
        </b-col>

        <b-col cols="12" sm="4" md="4" lg="2" xl="2">
          <b-row class="d-flex justify-content-start align-items-center radio-button">
            <input
              type="radio"
              id="capitalProductData.investmentTerm_radio_month"
              value="month"
              v-model="capitalProductData.investmentTermType"
            />
            <label class="radio-text mt-2" for="radio_month">Hónap </label>

            <input
              type="radio"
              id="capitalProductData.investmentTerm_radio_year"
              value="year"
              v-model="capitalProductData.investmentTermType"
              class="ml-2"
            />
            <label class="radio-text mt-2" for="radio_year">Év </label>
          </b-row>
        </b-col>
      </b-row>
      <label for="capitalProductData.yieldExpectation">Hozamelvárás</label>

      <b-form-input
        id="capitalProductData.yieldExpectation"
        v-model="capitalProductData.yieldExpectation"
        placeholder="Adja meg a hozamelvárást"
        trim
      ></b-form-input>
    </FormSectionContainer>

    <FormSectionContainer
      index="2"
      title="Egyedi feltételek és kizárások"
      :key="this.guarantee.uniqueConditions[0] ? this.guarantee.uniqueConditions[0].id : 'unqiue'"
    >
      <UniqueConditionsSelector
        @unique-conditions="handleUniqueConditions($event)"
        :alreadySelected="guarantee.uniqueConditions"
      />
    </FormSectionContainer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormSectionContainer from '../components/FormSectionContainer.vue'
import UniqueConditionsSelector from '../components/UniqueConditionsSelector.vue'
import * as CompetitionApi from '../../../api/competition'
export default {
  props: {
    isTouched: { type: Boolean, required: true }
  },
  data() {
    return {
      capitalProductData: {
        finance: '',
        financeMin: '',
        financeMax: '',
        ownershipShare: '',
        investmentTermMin: '',
        investmentTermMax: '',
        investmentTermType: 'month',
        yieldExpectation: ''
      },
      guarantee: {
        uniqueConditions: []
      },
      touched: this.isTouched
    }
  },
  computed: {
    ...mapGetters(['newFundDto']),
    finance() {
      if (this.touched) {
        return this.capitalProductData.finance.length > 0
      } else {
        return null
      }
    },
    ownershipShare() {
      if (this.touched) {
        return this.capitalProductData.ownershipShare.length > 0
      } else {
        return null
      }
    },
    investmentTermMin() {
      if (this.touched) {
        return this.capitalProductData.investmentTermMin.length > 0
      } else {
        return null
      }
    },
    investmentTermMax() {
      if (this.touched) {
        return this.capitalProductData.investmentTermMax.length > 0
      } else {
        return null
      }
    },
    finalResult() {
      if (
        this.capitalProductData.finance.length > 0 &&
        this.capitalProductData.investmentTermMin !== '' &&
        this.capitalProductData.investmentTermMax !== '' &&
        this.capitalProductData.ownershipShare.length > 0
      ) {
        return this.$emit('is-step2-fields-filled', true)
      } else {
        return this.$emit('is-step2-fields-filled', false)
      }
    }
  },
  components: {
    FormSectionContainer,
    UniqueConditionsSelector
  },
  methods: {
    isNumber(evt, isMinusAllowed) {
      const isStarting0Allowed = !this.$route.path.includes('/create-fund')
      const input = evt.target.value
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
      const keyPressed = evt.key

      if (keyPressed === '-' && input.length === 0 && isMinusAllowed) {
        return
      }

      if (input.length === 0 && keyPressed === '0' && isStarting0Allowed) {
        evt.preventDefault()
        return
      }

      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault()
      }
    },
    addCompetitionAttribute(key, value) {
      this.$store.dispatch('setFundDtoPropertyAction', { [key]: value })
    },
    handleUniqueConditions(conditions) {
      this.guarantee.uniqueConditions = conditions
    }
  },
  watch: {
    capitalProductData: {
      handler(value) {
        this.finalResult
        this.addCompetitionAttribute('capitalProductData', value)
      },
      deep: true
    },
    guarantee: {
      handler(value) {
        this.finalResult
        this.addCompetitionAttribute('guarantee', value)
      },
      deep: true
    },
    isTouched() {
      this.touched = this.isTouched
    }
  },
  async beforeMount() {
    const { competitionId } = this.$route.query
    if (competitionId) {
      try {
        const fundResult = await CompetitionApi.getCompetitionWithDetails(competitionId)

        this.capitalProductData = fundResult.fundId.capitalProductData

        this.guarantee = fundResult.fundId.guarantee
      } catch (e) {
        console.log(e)
      }
    } else {
      if (this.newFundDto.guarantee) {
        this.guarantee = this.newFundDto.guarantee
      }
      if (this.newFundDto.capitalProductData) {
        this.capitalProductData = this.newFundDto.capitalProductData
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.radio-text {
  font-weight: 400;
  font-size: 14px;
  color: black;
  text-transform: none;
}

input[type='radio'] {
  width: 20px;
  height: 20px;
  border: 1px solid #bbc1d3;
}

input[type='radio']:after {
  border-radius: 20px;
  content: '';
  display: inline-block;
}

input[type='radio']:checked:after {
  width: 20px;
  height: 20px;
  background-color: white;
  border: 6px solid #00903c;
}

.radio-button {
  margin-top: 5px;
}
@media all and (max-width: 576px) {
  .radio-button {
    margin-left: 10px;
    margin-top: 10px;
  }
}

.create-fund-error-border {
  border: 2px solid #ba3b46 !important;
}

.create-fund-error-message {
  color: #ba3b46;
  text-align: right;
  font-size: 14px;
}
</style>
